import type { SxProps, Theme } from '@mui/material';
import { FONT_ENUM } from '../../../../types/global/fonts.types';

/**
 * Desktop row layout only at lg+ (≥1200px viewport).
 * 1024×1366 / 1024×600 and brand manage drawer (~50vw) use stacked layout below lg.
 */
export const brandSubmissionGridColumns = {
    xs: '1fr',
    lg: '112px minmax(0, 1fr) 108px 40px 52px 44px',
} as const;

export const brandSubmissionGridSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: brandSubmissionGridColumns,
    columnGap: { xs: 0, lg: 2 },
    rowGap: { xs: 2, lg: 0 },
    alignItems: 'center',
    justifyItems: { xs: 'center', lg: 'unset' },
    px: { xs: 2, lg: 3 },
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
};

export const brandSubmissionHeaderSx: SxProps<Theme> = {
    fontFamily: FONT_ENUM.MAIN_MEDIUM,
    fontSize: 9,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: '#99907c',
    whiteSpace: 'nowrap',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

/** Stacked layout section label — shown below lg */
export const brandSubmissionMobileLabelSx: SxProps<Theme> = {
    ...brandSubmissionHeaderSx,
    fontSize: 10,
    letterSpacing: '0.2em',
    textAlign: 'center',
    width: '100%',
    mb: 0.5,
};
